/** @format */

import { useMutation } from "@tanstack/react-query";
import service from "../utils/service";

const useAddSurvey = () =>  useMutation({
    mutationKey: ["addSurvey"],
    mutationFn: (surveyToAdd) => service.addSurvey(surveyToAdd),
  });

export default useAddSurvey;
